import { I18nManager } from 'react-native';
import RNRestart from 'react-native-restart';

import { getUserLanguage } from '@webtrader/core/i18n';
import { checkIsNative } from '@webtrader/core/validators/device';

export const initializeRTLForCurrentLanguage = () => {
  if (checkIsNative()) {
    const language = getUserLanguage();

    // Set RTL immediately for Arabic without restarting
    // This handles the case when app starts with Arabic already set
    if (language === 'ar_AE') {
      I18nManager.forceRTL(true);
    } else {
      I18nManager.forceRTL(false);
    }
  }
};

export const resetLayoutOnLanguageChange = () => {
  checkIsNative() ? nativeResetLayoutOnLanguageChange() : webResetLayoutOnLanguageChange();
};

const nativeResetLayoutOnLanguageChange = () => {
  // Apply RTL/LTR changes and restart app according to languages.
  const language = getUserLanguage();

  if (language === 'ar_AE') {
    I18nManager.forceRTL(true);
  } else {
    I18nManager.forceRTL(false);
  }
  RNRestart.Restart();
};

const webResetLayoutOnLanguageChange = () => {
  window.location.reload();
};
